import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Image } from 'react-native';
import PromoBannerActions from './PromoBannerActions';
import { getBannerFeedImage } from '../../data/promoSocialDemo';

export default function SocialBannerCard({
  item,
  viewCount,
  liked,
  likeCount,
  commentCount,
  shareCount,
  onLike,
  onOpenLike,
  onComment,
  onShare,
  onOpenDetail,
}) {
  const image = getBannerFeedImage(item);

  const handleImagePress = () => {
    onOpenDetail();
  };

  return (
    <View style={styles.card}>
      <TouchableOpacity style={styles.promoCard} activeOpacity={0.9} onPress={handleImagePress}>
        <Image
          source={{ uri: image }}
          style={styles.image}
          resizeMode="cover"
        />
      </TouchableOpacity>
      <PromoBannerActions
        viewCount={viewCount}
        liked={liked}
        likeCount={likeCount}
        commentCount={commentCount}
        shareCount={shareCount}
        onLike={onLike}
        onOpenLike={onOpenLike}
        onComment={onComment}
        onShare={onShare}
        showCommentLink={false}
      />
      {item.description && item.description.trim() !== '' && (
        <TouchableOpacity onPress={onOpenDetail} activeOpacity={0.7} style={styles.captionWrap}>
          <Text style={styles.caption} numberOfLines={2}>
            {item.description}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    overflow: 'clip',
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
    paddingBottom: 4,
  },
  promoCard: {
    width: '100%',
    minHeight: 145,
    overflow: 'hidden',
    backgroundColor: '#E2E8F0',
  },
  image: {
    width: '100%',
    minHeight: 145,
    aspectRatio: 780 / 290,
  },
  captionWrap: {
    paddingHorizontal: 12,
    marginTop: 2,
    marginBottom: 4,
  },
  caption: {
    fontSize: 13,
    fontFamily: 'Poppins',
    color: '#0F172A',
    lineHeight: 18,
  },
  viewComments: {
    fontSize: 13,
    fontFamily: 'Poppins',
    color: '#64748B',
    lineHeight: 18,
    marginBottom: 4,
  },
});
